import { createContext, useContext } from 'react';
var defaultContext = {
    paths: [],
    addPath: function () { return null; },
};
export var HorizontalMenuContext = createContext(defaultContext);
export var useHorizontalMenuContext = function () { return useContext(HorizontalMenuContext); };
